import React from "react";
import {Progress} from "reactstrap";

const Loading = ({isLoading = false}) => (
    <Progress className={isLoading ? "visible" : "invisible"} animated color="info" value={100} style={{borderRadius: "0px"}}>Моля изчакайте. Зарежда се...</Progress>
);

export default Loading